const userDashboardHomeDictEN = {
  bonus: "Daily income",
  balance: "Balance",
  inbound: "Inbound",
  outbound: "Outbound",
  every: "Every ",
  AmountIsAutomaticallyTransferredToWallet:
    " the amount is automatically transferred to the main wallet.",
  currentlyYouCan: "Currently you can use up to ",
  ofYourExtracoin: " from your Extracredit balance to pay for your purchases.",
  extracoinOnlyBetweenUsers: "Extracredit is only for purchases and transfers between users!",
  indirects: "Indirects",
  stats: "Statistics",
  plan: "Plan",
  subscription: "Subscription",
  daysLeft: " days left",
  activation: "Activation",
  seeAllDirects: "See all directs",
  youDontHaveAny: "You don't have any direct users in your economic circle yet.",
  days: "days",
  months: "months",
  year: "year",
  numberOfUsersInNetwork: "Number of users added to your network",
  date: "Date",
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  quantity: "Quantity",
  referralLinks: "Referral links",
  shareReferrals: "Share referrals",
  share: "Share",
  copy: "Copy",
  copiedToClipboard: "Copied to clipboard.",
  copied: "Copied",
  notActive: "Inactive User",
  balanceCommission: "commissions",
  balanceSale: "sales",
  message: "Message",
  imAware: "I'm aware",
  alert: "Alert",
  notEnabled:
    "Your account cannot ship products at this time. Edit your profile address to a valid address.",
  inAnalysis: "Your provided package pickup address is currently being under analysis.",
  enabled: "Your provided package pickup address is apt to ship products.",
  thisIsPickupAddress: "This address will be used by shipping companies to pickup your packages",
  renewSubscriptionValue: "Renew subscription value",
  referralLinksExplanation:
    "Use these links to register new users in the various plans and automatically increase your economic circle by earning commissions and daily income according to our compensation plan.",
  profile: "Profile",
  activationRequirements: "For activation, 1 registration or 1 purchase per month is required.",
  safePayment: "Safe payment",
  balanceForExternalAds: "Balance for external ads",
  youCanUseThisAmountToMakeExternalAds: "You can use this balance to make external ads.",
  transaction: "Transaction",
  transactions: "Transactions",
  create: "Create",
  qrCodeOfTransaction: "Qr Code of Transaction",
  paymentDate: "Payment date",
  payWithExtracredit: "Pay with Extracredit",
  payWithWallet: "Pay with Wallet",
  sumOfValuesIsDifferent: "The sum of the values is different from the transaction value",
  transactionDone: "Transaction done successfully!",
  to: "To",
  awaitingPayment: "Awaiting payment",
  payer: "Payer",
  idOfTransaction: "Transaction ID",
  makeAnotherPayment: "Make another payment",
  qrcodereferralLinks: "Qr Code of referral link",
  economicCircle: "Economic circle",
  yourNetworkOfInfluence: "Your network of influence",
  close: "Close",
  members: "Members",
  viewNetwork: "View network",
  networkCommissionLabel: "Network commission",
  dailyIncomeLabel: "Daily income",
  networkReferralCommissionLabel: "Referral commission",
  networkReferralCommissionInfo: "Commissions received when people in your network (direct and indirect referrals) buy a plan. Does not include your own revenue.",
  networkSalesCommissionLabel: "Sales commission",
  networkSalesCommissionInfo: "Commissions received on purchases, sales and transfers made by people in your network. Does not include what you earn from your own sales.",
  roleCustomer: "Customer",
  rolePromoter: "Promoter",
  roleManager: "Manager",
  roleManagerAssociation: "Manager Association",
  rolePartner: "Partner",
  roleSeller: "Seller",
  roleStore: "Store",
  doTheDiagnosis: "Participate in the Evaluation",
  associationConfimeaShareTitle: "Business Square link",
  associationConfimeaShareDescription:
    "Share this link so new Managers can register using your association document.",
};

export default userDashboardHomeDictEN;
